import request from "@/router/axios";

//loanCertificateKeyBeGetOutStoragePage 查询钥匙 出库
export const loanCertificateKeyBeGetOutStoragePage = (current, size, params, search) => {
  return request({
    url: `/api/blade-loanCertificateKeyBeGetOutStorage/loanCertificateKeyBeGetOutStorage/page`,
    method: "post",
    data: {
      current,
      size,
      ...params,
      ...search,
    },
  });
};

// 借钥匙借证书列表接口
export const borrowingPage = (current, size, params, search) => {
  return request({
    url: `/api/blade-borrowkeycerfiticate/borrowkeycerfiticate/borrowing_page`,
    method: "post",
    data: {
      current,
      size,
      ...params,
      ...search,
    },
  });
};


export const loanCredentialManagementPage = (current, size, params, search) => {
  return request({
    url: `/api/blade-loanCredentialManagement/loanCredentialManagement/page`,
    method: "post",
    data: {
      current,
      size,
      ...params,
      ...search,
    },
  });
};
//

// 详情 借钥匙
export const loanCertificateKeyBeGetOutStorageGetByIdDetails = (loanCredentialManagementId,type) => {
  return request({
    url: `/api/blade-loanCertificateKeyBeGetOutStorage/loanCertificateKeyBeGetOutStorage/getByIdDetails`,
    method: "post",
    data: {
      loanCredentialManagementId,
      type
    },
  });
};

//  归还证书或者钥匙提交
export const returnSumbit = (data) => {
  return request({
    url: `/api/blade-borrowkeycerfiticate/borrowkeycerfiticate/return_sumbit`,
    method: "post",
    data: data
  });
};

//loanCertificateKeyBeGetOutStoragePage 查询还钥匙
export const returnPage = (params, search) => {
  return request({
    url: `/api/blade-borrowkeycerfiticate/borrowkeycerfiticate/return_page`,
    method: "post",
    data: {
      ...params,
      ...search,
    },
  });
};

//  借证书或者钥匙提交
export const borrowkeycerfiticateSumbit = (data) => {
  return request({
    url: `/api/blade-borrowkeycerfiticate/borrowkeycerfiticate/sumbit`,
    method: "post",
    data: data
  });
};

